import * as queries from "./queries"
import * as mutations from "./mutations"

export const dashboards = {
  queries: queries,
  mutations: mutations
}